var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainZksync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chain-zksync_svg__clip0_228_11660)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.759 6.25l5.641 5.604-5.641 5.605v-3.07l-5.374-.004 5.374-3.942V6.25zm-5.518.223v3.1l5.331.003-5.33 3.942v4.164L3.6 12.077l5.641-5.604zm6.816 2.898v1.73l-2.71 1.988 2.71.002v1.247l2.5-2.484-2.5-2.483zM5.443 12.077l2.5 2.484v-1.697l2.693-1.992-2.693-.002V9.594l-2.5 2.483z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chain-zksync_svg__clip0_228_11660"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMi4wMDAxIiByPSIxMiIgZmlsbD0id2hpdGUiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIyOF8xMTY2MCkiPgo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyLjAwMDEiIHI9IjEyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NTg3IDYuMjUwMTJMMjAuNCAxMS44NTQ0TDE0Ljc1ODcgMTcuNDU4NlYxNC4zODg5TDkuMzg1MjcgMTQuMzg1MkwxNC43NTg3IDEwLjQ0MzFMMTQuNzU4NyA2LjI1MDEyWk05LjI0MTI5IDYuNDczMTZWOS41NzIyN0wxNC41NzI0IDkuNTc1OTFMOS4yNDEyOSAxMy41MTg1VjE3LjY4MTZMMy41OTk5OCAxMi4wNzc0TDkuMjQxMjkgNi40NzMxNlpNMTYuMDU3MyA5LjM3MDY1VjExLjEwMUwxMy4zNDcgMTMuMDg5M0wxNi4wNTczIDEzLjA5MTJMMTYuMDU3MyAxNC4zMzgxTDE4LjU1NzQgMTEuODU0NEwxNi4wNTczIDkuMzcwNjVaTTUuNDQyNTUgMTIuMDc3NEw3Ljk0MjcgMTQuNTYxMUw3Ljk0MjcgMTIuODYzN0wxMC42MzYxIDEwLjg3MThMNy45NDI3IDEwLjg3TDcuOTQyNyA5LjU5MzY4TDUuNDQyNTUgMTIuMDc3NFoiIGZpbGw9ImJsYWNrIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjI4XzExNjYwIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgChainZksync as ReactComponent };